module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-edit",
    attrs: {
      "id": "reportEditParent"
    }
  }, [_c('div', [_c('transition', {
    attrs: {
      "name": "notifyFade"
    }
  }, [(_vm.notify !== null) ? _c('div', {
    staticClass: "notify-message-parent"
  }, [_c('div', {
    staticClass: "notify-message"
  }, [_c('div', {
    staticClass: "alert alert-dismissible",
    class: {
      'alert-success': _vm.notify.success, 'alert-danger': _vm.notify.danger, 'alert-warning': _vm.notify.warning
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#",
      "data-dismiss": "alert",
      "aria-label": "close",
      "title": "close"
    }
  }, [_vm._v("×")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('message_i18n' in _vm.notify),
      expression: "'message_i18n' in notify"
    }],
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.notify.message_i18n)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('message' in _vm.notify),
      expression: "'message' in notify"
    }],
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.notify.message)))])])])]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "notifyFade"
    }
  }, [(_vm.reportSendNotify !== null) ? _c('div', {
    staticClass: "notify-message-parent"
  }, [_c('div', {
    staticClass: "notify-message"
  }, [_c('div', {
    staticClass: "alert alert-dismissible",
    class: {
      'alert-success': _vm.reportSendNotify.success, 'alert-danger': _vm.reportSendNotify.danger, 'alert-warning': _vm.reportSendNotify.warning
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#",
      "data-dismiss": "alert",
      "aria-label": "close",
      "title": "close"
    }
  }, [_vm._v("×")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('message_i18n' in _vm.reportSendNotify),
      expression: "'message_i18n' in reportSendNotify"
    }],
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.reportSendNotify.message_i18n)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('message' in _vm.reportSendNotify),
      expression: "'message' in reportSendNotify"
    }],
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.reportSendNotify.message)))])])])]) : _vm._e()])], 1), _c('div', {
    attrs: {
      "id": "reportTop"
    }
  }, [_c('div', {
    attrs: {
      "id": "reportSticky"
    }
  }, [(_vm.isReportSend) ? _c('div', [_c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])]), _c('li', [_c('a', {
    on: {
      "click": _vm.goReportHistoryList
    }
  }, [(_vm.$route.params.type === 'facility') ? [_vm._v(_vm._s(_vm.$t('Select Facility')))] : _vm._e(), (_vm.$route.params.type === 'facility_person') ? [_vm._v(_vm._s(_vm.$t('Select Facility Person')))] : _vm._e(), (_vm.$route.params.type === 'clinic') ? [_vm._v(_vm._s(_vm.$t('Select Clinic')))] : _vm._e(), (_vm.$route.params.type === 'care_office') ? [_vm._v(_vm._s(_vm.$t('Select Care Office')))] : _vm._e()], 2)]), _c('li', [_c('a', {
    on: {
      "click": _vm.goReportHistory
    }
  }, [_vm._v(_vm._s(_vm.$t('Report History')))])]), _c('li', {
    staticClass: "active"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Report Edit')))])])]) : (!_vm.isReportDetail) ? _c('div', [_c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])]), _c('li', [_c('a', {
    on: {
      "click": _vm.goFacility
    }
  }, [_vm._v(_vm._s(_vm.$t('Select Facility')))])]), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goPatient()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Outpatient.Search Patients')))])]), _c('li', {
    staticClass: "active"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Report Edit')))])])]) : (_vm.isReportDetail) ? _c('div', [_c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('a', {
    on: {
      "click": _vm.goPatientsList
    }
  }, [_vm._v(_vm._s(_vm.$t('Outpatient.Search Patients')))])]), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goPatientsReport()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Report Show')))])]), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goReportDetail()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Report Detail')))])]), _c('li', {
    staticClass: "active"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Report Edit')))])])]) : _vm._e(), _c('form', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHeaderOpen),
      expression: "isHeaderOpen"
    }]
  }, [_c('input', {
    staticClass: "submit-stop hide",
    attrs: {
      "type": "text"
    }
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('label', {
    staticClass: "btn btn-default",
    class: {
      'btn-info active': (_vm.word50 === '')
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search_word50', '')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Word50.All')))]), _c('label', {
    staticClass: "btn btn-default",
    class: {
      'btn-info active': (_vm.word50 === '0')
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search_word50', '0')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Word50.W0')))]), _c('label', {
    staticClass: "btn btn-default",
    class: {
      'btn-info active': (_vm.word50 === '1')
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search_word50', '1')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Word50.W1')))]), _c('label', {
    staticClass: "btn btn-default",
    class: {
      'btn-info active': (_vm.word50 === '2')
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search_word50', '2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Word50.W2')))]), _c('label', {
    staticClass: "btn btn-default",
    class: {
      'btn-info active': (_vm.word50 === '3')
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search_word50', '3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Word50.W3')))]), _c('label', {
    staticClass: "btn btn-default",
    class: {
      'btn-info active': (_vm.word50 === '4')
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search_word50', '4')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Word50.W4')))]), _c('label', {
    staticClass: "btn btn-default",
    class: {
      'btn-info active': (_vm.word50 === '5')
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search_word50', '5')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Word50.W5')))]), _c('label', {
    staticClass: "btn btn-default",
    class: {
      'btn-info active': (_vm.word50 === '6')
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search_word50', '6')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Word50.W6')))]), _c('label', {
    staticClass: "btn btn-default",
    class: {
      'btn-info active': (_vm.word50 === '7')
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search_word50', '7')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Word50.W7')))]), _c('label', {
    staticClass: "btn btn-default",
    class: {
      'btn-info active': (_vm.word50 === '8')
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search_word50', '8')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Word50.W8')))]), _c('label', {
    staticClass: "btn btn-default",
    class: {
      'btn-info active': (_vm.word50 === '9')
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search_word50', '9')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Word50.W9')))]), _c('label', {
    staticClass: "btn btn-default",
    class: {
      'btn-info active': (_vm.word50 === '10')
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search_word50', '10')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Word50.W10')))])]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patientName),
      expression: "patientName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "patient_name",
      "placeholder": _vm.$t('placeholder.patient')
    },
    domProps: {
      "value": _vm._s(_vm.patientName)
    },
    on: {
      "keydown": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.onDiffConfirm('search', 'false')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.patientName = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onDiffConfirm('search', 'false')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])]), (_vm.patient != null) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHeaderOpen),
      expression: "isHeaderOpen"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.isAllSaveDisabled
    },
    on: {
      "click": function($event) {
        _vm.onClickAllSaveReport({
          type: 'report',
          post_status: 'temp',
          update_resend: false
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.onPrintModalShow()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Print')))])]), _c('a', {
    staticClass: "btn btn-warning",
    class: {
      'disabled': !_vm.isSendPostOk
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#confirm_teiki_modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Send Report Ordinary')))])]), _c('a', {
    staticClass: "btn btn-danger",
    class: {
      'disabled': !_vm.isSendPostOk
    },
    on: {
      "click": function($event) {
        _vm.onSokujiModalShow(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Send Report Immediately')))])])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('a', {
    staticClass: "btn btn-default",
    class: {
      disabled: !_vm.isAutoConsultPoints
    },
    on: {
      "click": function($event) {
        _vm.onAutoConsultPoints()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-magic"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Auto Input')))])]), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.onBulkDateModalShow()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Auto Input Date')))])])])]), _c('div', {
    staticClass: "row margin-top-divide"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.disp_item')))]), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckRoomNo),
      expression: "isCheckRoomNo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckRoomNo) ? _vm._i(_vm.isCheckRoomNo, null) > -1 : (_vm.isCheckRoomNo)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.isCheckRoomNo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isCheckRoomNo = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isCheckRoomNo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckRoomNo = $$c
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.room_no')))])]), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckHaiyaku),
      expression: "isCheckHaiyaku"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckHaiyaku) ? _vm._i(_vm.isCheckHaiyaku, null) > -1 : (_vm.isCheckHaiyaku)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.isCheckHaiyaku,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isCheckHaiyaku = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isCheckHaiyaku = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckHaiyaku = $$c
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.haiyaku_naiyou')))])]), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckHenkou),
      expression: "isCheckHenkou"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckHenkou) ? _vm._i(_vm.isCheckHenkou, null) > -1 : (_vm.isCheckHenkou)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.isCheckHenkou,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isCheckHenkou = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isCheckHenkou = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckHenkou = $$c
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.henkouten')))])]), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckShidou),
      expression: "isCheckShidou"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckShidou) ? _vm._i(_vm.isCheckShidou, null) > -1 : (_vm.isCheckShidou)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.isCheckShidou,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isCheckShidou = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isCheckShidou = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckShidou = $$c
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.shidou_naiyou')))])]), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckKakunin) ? _vm._i(_vm.isCheckKakunin, null) > -1 : (_vm.isCheckKakunin)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.isCheckKakunin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isCheckKakunin = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isCheckKakunin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckKakunin = $$c
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.kakunin_jikou')))])])])]), _c('div', {
    staticClass: "row margin-top-divide"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': !_vm.isPatientPrev
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.patientPrev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.patient_prev')))])])]), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "4px",
      "padding": "5px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.patient['patient-name']))])]), _c('span', [_vm._v(" ")]), _c('span', {
    staticClass: "label",
    class: _vm.getDispColor,
    staticStyle: {
      "margin-top": "4px",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.display_now')))])]), _c('div', {
    staticClass: "col-xs-7"
  }, [_c('strong', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.totalCount ? _vm.totalCount : 0) + " " + _vm._s(_vm.$t('report.patient_count')))]), _c('span', [_vm._v(_vm._s(_vm.$t('report.patient_select')))]), (!_vm.isSmartPhone) ? _c('div', [_c('a', {
    staticClass: "btn btn-link mp0",
    on: {
      "click": function($event) {
        _vm.onHeaderOpenClose(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-up"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.header_close')))])])]) : _vm._e()])])]), _c('div', {
    staticClass: "col-xs-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': !_vm.isPatientNext
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.patientNext()
      }
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.patient_next')))]), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHeaderOpen),
      expression: "!isHeaderOpen"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': !_vm.isPatientPrev
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.patientPrev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.patient_prev')))])])]), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "4px",
      "padding": "5px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.patient['patient-name']))])]), _c('span', [_vm._v(" ")]), _c('span', {
    staticClass: "label",
    class: _vm.getDispColor,
    staticStyle: {
      "margin-top": "4px",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.display_now')))])]), _c('div', {
    staticClass: "col-xs-7"
  }, [_c('strong', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.totalCount ? _vm.totalCount : 0) + " " + _vm._s(_vm.$t('report.patient_count')))]), _c('span', [_vm._v(_vm._s(_vm.$t('report.patient_select')))]), _c('br'), _c('a', {
    staticClass: "btn btn-link mp0",
    on: {
      "click": function($event) {
        _vm.onHeaderOpenClose(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-down"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.header_open')))])])])])]), _c('div', {
    staticClass: "col-xs-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': !_vm.isPatientNext
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.patientNext()
      }
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.patient_next')))]), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])])]) : _vm._e()])]), (_vm.loading || !_vm.searchCallbackFlag) ? _c('div', [_c('form', {
    staticClass: "reportForm"
  }), _vm._m(0)]) : _c('div', {
    class: {
      'report-smartphone-wrap': _vm.isSmartPhone
    }
  }, [_c('form', {
    staticClass: "reportForm"
  }, [(_vm.patient === null && !_vm.reportDataExists) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Data')))])])])])]) : _vm._e(), (_vm.patient !== null) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-3 text-center"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [_c('p', [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.patient['avartar-path']),
      expression: "!patient['avartar-path']"
    }],
    staticClass: "profile fa fa-user"
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.patient['avartar-path']),
      expression: "patient['avartar-path']"
    }],
    staticStyle: {
      "max-width": "160px",
      "max-height": "160px"
    },
    attrs: {
      "src": _vm.patient['avartar-path'] + '?token=' + _vm.authToken
    },
    on: {
      "click": function($event) {
        _vm.onClickImageModalShow()
      }
    }
  })]), _c('h4', [_vm._v(_vm._s(_vm.patient['patient-name'])), _c('br'), _vm._v("(" + _vm._s(_vm.patient['patient-name-furigana']) + ")")]), _c('p', {
    staticClass: "profile"
  }, [_vm._v(_vm._s(_vm.$t('attributes.patient.sex')) + " : " + _vm._s(_vm.patient['sex'])), _c('br'), _vm._v(_vm._s(_vm.$t('attributes.patient.birthday')) + " : " + _vm._s(_vm.patient['birthday'])), _c('br'), _vm._v(_vm._s(_vm.$t('attributes.patient.age')) + " : " + _vm._s(_vm.patient['age']))]), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.goPalnDetail()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('report.plan_reference')))])])]), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('report.facility')))]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.facility['facility-name']))]), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.goFacilityDetail(_vm.facility['facility-id'], _vm.facility['facility-type'])
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('report.facility_reference')))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckRoomNo),
      expression: "isCheckRoomNo"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('attributes.patient.room')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan['room_no']),
      expression: "plan['room_no']"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "name": "plan[room_no]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": _vm._s(_vm.plan['room_no'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.plan,
          $$idx = 'room_no';
        if (!Array.isArray($$exp)) {
          _vm.plan['room_no'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('attributes.patient.special-comment')))]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan['special_comment']),
      expression: "plan['special_comment']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.special_comment_format
    },
    attrs: {
      "rows": "4",
      "maxlength": "500",
      "name": "plan[special_comment]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": _vm._s(_vm.plan['special_comment'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.plan,
          $$idx = 'special_comment';
        if (!Array.isArray($$exp)) {
          _vm.plan['special_comment'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.special_comment_format),
      expression: "required.special_comment_format"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.print_length')))])])])]), _c('table', {
    staticClass: "table table-bordered table-report margin-top"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col-span-4 hidden-xs",
    attrs: {
      "colspan": "4"
    }
  }, [_c('a', {
    staticClass: "btn btn-default",
    class: {
      'disabled': !_vm.isReportHistNext
    },
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.onReportHistNext()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.zenkai')))])]), _c('a', {
    staticClass: "btn btn-default",
    class: {
      'disabled': !_vm.isReportHistPrev
    },
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.onReportHistPrev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.jikai')))])])]), _c('td', {
    staticClass: "col-span-4 text-right",
    attrs: {
      "colspan": "4"
    }
  }, [(_vm.isPostStatusPost) ? [(_vm.isAdminOrPharmacist) ? [_c('a', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': !_vm.isRequiredComplete
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#confirm_update_modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Update')))])]), _c('a', {
    staticClass: "btn btn-warning",
    class: {
      disabled: !_vm.isEdit
    },
    on: {
      "click": function($event) {
        _vm.onReportClear()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Clear')))])])] : _vm._e()] : [(_vm.isEditBtn) ? _c('span', [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.onEditMode()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Edit')))])]), (!_vm.isReportDetail && !_vm.isReportSend) ? [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#add_confirm_modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Add Make')))])]), (_vm.isAdminOrPharmacist && _vm.report['other_no'] !== null && _vm.report['other_no'] > 0) ? [_c('a', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#delete_confirm_modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Delete')))])])] : _vm._e()] : _vm._e()], 2) : _c('span', [_c('a', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': !_vm.isRequiredComplete
    },
    on: {
      "click": function($event) {
        _vm.onClickSaveReport({
          type: 'report',
          post_status: 'no_post',
          update_resend: false
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Complete')))])]), _c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.isEdit
    },
    on: {
      "click": function($event) {
        _vm.onClickSaveReport({
          type: 'report',
          post_status: 'temp',
          update_resend: false
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), (!_vm.isReportDetail && !_vm.isReportSend) ? [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#add_confirm_modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Add Make')))])]), (_vm.isAdminOrPharmacist && _vm.report['other_no'] !== null && _vm.report['other_no'] > 0) ? [_c('a', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#delete_confirm_modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Delete')))])])] : _vm._e()] : _vm._e()], 2), _c('a', {
    staticClass: "btn btn-warning",
    class: {
      disabled: !_vm.isEdit
    },
    on: {
      "click": function($event) {
        _vm.onReportClear()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Clear')))])])]], 2)]), _c('tr', [_c('th', {
    staticClass: "hidden-xs col-sm-1"
  }, [_vm._v(_vm._s(_vm.$t('report.shohoubi')))]), _c('td', {
    staticClass: "hidden-xs col-sm-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.reportHist['prescribe-date']))])]), _c('th', {
    staticClass: "hidden-xs col-sm-1"
  }, [_vm._v(_vm._s(_vm.$t('report.chouzaibi')))]), _c('td', {
    staticClass: "hidden-xs col-sm-2"
  }, [_vm._v(_vm._s(_vm.reportHist['make-date']))]), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v(_vm._s(_vm.$t('report.shohoubi')))]), _c('td', {
    staticClass: "col-sm-2"
  }, [_c('date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.report['prescribe_date']),
      expression: "report['prescribe_date']",
      modifiers: {
        "lazy": true
      }
    }],
    class: {
      required: _vm.required.prescribe_date || _vm.required.prescribe_date_format
    },
    attrs: {
      "name": "report[prescribe_date]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": (_vm.report['prescribe_date'])
    },
    on: {
      "change": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'prescribe_date';
        if (!Array.isArray($$exp)) {
          _vm.report['prescribe_date'] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }, _vm.onPrescribeDateChange]
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.prescribe_date),
      expression: "required.prescribe_date"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])], 1), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v(_vm._s(_vm.$t('report.chouzaibi')))]), _c('td', {
    staticClass: "col-sm-2"
  }, [_c('date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.report['make_date']),
      expression: "report['make_date']",
      modifiers: {
        "lazy": true
      }
    }],
    class: {
      required: _vm.required.make_date || _vm.required.make_date_format
    },
    attrs: {
      "name": "report[make_date]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": (_vm.report['make_date'])
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.report,
          $$idx = 'make_date';
        if (!Array.isArray($$exp)) {
          _vm.report['make_date'] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.make_date),
      expression: "required.make_date"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])], 1)]), _c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('Clinic Name')))]), _c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportHist['clinic-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('Clinic Name')))]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "autocomplete-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['ac_clinic_name']),
      expression: "report['ac_clinic_name']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.clinic_id
    },
    attrs: {
      "id": "clinic_name_autocomplete",
      "type": "text",
      "disabled": !_vm.isEdit,
      "placeholder": _vm.$t('placeholder.clinic_name'),
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.report['ac_clinic_name'])
    },
    on: {
      "blur": _vm.clearClinics,
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'ac_clinic_name';
        if (!Array.isArray($$exp)) {
          _vm.report['ac_clinic_name'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), (_vm.clinics && _vm.clinics.length > 0) ? _c('ul', {
    staticClass: "options-list"
  }, _vm._l((_vm.clinics), function(clinic) {
    return _c('li', [_c('span', {
      attrs: {
        "data-id": clinic.id,
        "data-name": clinic.attributes['clinic-name']
      },
      on: {
        "mousedown": function($event) {
          _vm.setSearchClinic(clinic.id, clinic.attributes['clinic-name'])
        }
      }
    }, [_vm._v(_vm._s(clinic.attributes['clinic-name']))])])
  })) : _vm._e(), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['clinic_name']),
      expression: "report['clinic_name']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.clinic_name
    },
    attrs: {
      "type": "hidden",
      "name": "report[clinic_name]"
    },
    domProps: {
      "value": _vm._s(_vm.report['clinic_name'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'clinic_name';
        if (!Array.isArray($$exp)) {
          _vm.report['clinic_name'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['clinic_id']),
      expression: "report['clinic_id']"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "name": "report[clinic_id]"
    },
    domProps: {
      "value": _vm._s(_vm.report['clinic_id'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'clinic_id';
        if (!Array.isArray($$exp)) {
          _vm.report['clinic_id'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.clinic_id),
      expression: "required.clinic_id"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])])]), _c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('Doctor Name')))]), _c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportHist['doctor-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('Doctor Name')))]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "autocomplete-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['ac_doctor_name']),
      expression: "report['ac_doctor_name']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.doctor_id
    },
    attrs: {
      "id": "doctor_name_autocomplete",
      "type": "text",
      "disabled": !_vm.isEdit,
      "placeholder": _vm.$t('placeholder.doctor_name'),
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.report['ac_doctor_name'])
    },
    on: {
      "blur": _vm.clearDoctors,
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'ac_doctor_name';
        if (!Array.isArray($$exp)) {
          _vm.report['ac_doctor_name'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), (_vm.doctors && _vm.doctors.length > 0) ? _c('ul', {
    staticClass: "options-list"
  }, _vm._l((_vm.doctors), function(doctor) {
    return _c('li', [_c('span', {
      attrs: {
        "data-id": doctor.id,
        "data-name": doctor.attributes['doctor-name']
      },
      on: {
        "mousedown": function($event) {
          _vm.setSearchDoctor(doctor.id, doctor.attributes['doctor-name'])
        }
      }
    }, [_vm._v(_vm._s(doctor.attributes['doctor-name']))])])
  })) : _vm._e()]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['doctor_name']),
      expression: "report['doctor_name']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.doctor_name
    },
    attrs: {
      "type": "hidden",
      "name": "report[doctor_name]"
    },
    domProps: {
      "value": _vm._s(_vm.report['doctor_name'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'doctor_name';
        if (!Array.isArray($$exp)) {
          _vm.report['doctor_name'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['doctor_id']),
      expression: "report['doctor_id']"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "name": "report[doctor_id]"
    },
    domProps: {
      "value": _vm._s(_vm.report['doctor_id'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'doctor_id';
        if (!Array.isArray($$exp)) {
          _vm.report['doctor_id'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.doctor_id),
      expression: "required.doctor_id"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('Reportor Name')))]), _c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportHist['user-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('Reportor Name')))]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "autocomplete-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['ac_user_name']),
      expression: "report['ac_user_name']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.reportor_id
    },
    attrs: {
      "id": "user_name_autocomplete",
      "type": "text",
      "disabled": !_vm.isEdit,
      "placeholder": _vm.$t('placeholder.reportor_name'),
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.report['ac_user_name'])
    },
    on: {
      "blur": _vm.clearUsers,
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'ac_user_name';
        if (!Array.isArray($$exp)) {
          _vm.report['ac_user_name'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), (_vm.users && _vm.users.length > 0) ? _c('ul', {
    staticClass: "options-list"
  }, _vm._l((_vm.users), function(user) {
    return _c('li', [_c('span', {
      attrs: {
        "data-id": user.id,
        "data-name": user.attributes['user-name']
      },
      on: {
        "mousedown": function($event) {
          _vm.setSearchUser(user.id, user.attributes['user-name'])
        }
      }
    }, [_vm._v(_vm._s(user.attributes['user-name']))])])
  })) : _vm._e()]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['user_name']),
      expression: "report['user_name']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.user_name
    },
    attrs: {
      "type": "hidden",
      "name": "report[user_name]"
    },
    domProps: {
      "value": _vm._s(_vm.report['user_name'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'user_name';
        if (!Array.isArray($$exp)) {
          _vm.report['user_name'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['reportor_id']),
      expression: "report['reportor_id']"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "name": "report[reportor_id]"
    },
    domProps: {
      "value": _vm._s(_vm.report['reportor_id'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'reportor_id';
        if (!Array.isArray($$exp)) {
          _vm.report['reportor_id'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.reportor_id),
      expression: "required.reportor_id"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.report_type')))]), _c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportHist['report-type-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.report_type')))]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['report_type']),
      expression: "report['report_type']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.report_type
    },
    attrs: {
      "name": "report[report_type]",
      "disabled": !_vm.isEdit
    },
    on: {
      "change": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'report_type';
        if (!Array.isArray($$exp)) {
          _vm.report['report_type'] = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        } else {
          $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0])
        }
      }, function($event) {
        _vm.onChangeReportType()
      }]
    }
  }, _vm._l((_vm.getSelectReportType), function(reportType) {
    return _c('option', {
      domProps: {
        "value": reportType['key']
      }
    }, [_vm._v(_vm._s(reportType['val']))])
  })), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.report_type),
      expression: "required.report_type"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.teisyutsu')))]), _c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHistReportTypeClinic),
      expression: "isHistReportTypeClinic"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.clinic_send_check')))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-check'] === 1),
      expression: "reportHist['clinic-send-check'] === 1"
    }]
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-square-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.send_info_change')))]), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.send_type')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-type-post']),
      expression: "reportHist['clinic-send-type-post']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.post')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-type-fax']),
      expression: "reportHist['clinic-send-type-fax']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fax')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-type-email']),
      expression: "reportHist['clinic-send-type-email']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.email')))]), _c('br')]), _c('div', {
    staticClass: "col-xs-9 col-xs-offset-3"
  }, [_vm._l((_vm.getNameList('report.send_timing')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.reportHist['clinic-send-timing']),
        expression: "parseInt(list.id, 10) === reportHist['clinic-send-timing']"
      }]
    }, [_vm._v(_vm._s(list.text) + "  ")])
  }), _vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.reportHist['clinic-send-timing-hour']),
        expression: "parseInt(list.id, 10) === reportHist['clinic-send-timing-hour']"
      }]
    }, [_vm._v(_vm._s(list.text))])
  })], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-type-fax']),
      expression: "reportHist['clinic-send-type-fax']"
    }]
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fax"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.fax')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.reportHist['clinic-fax']))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-type-email']),
      expression: "reportHist['clinic-send-type-email']"
    }]
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.email')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.reportHist['clinic-email']))])])]), _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.fusezi')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-fusezi-flag'] === 1),
      expression: "reportHist['clinic-fusezi-flag'] === 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_ari')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-fusezi-flag'] !== 1),
      expression: "reportHist['clinic-fusezi-flag'] !== 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_nashi')))])])])]), (_vm.isSendSendInfoKey(_vm.reportHist, 'clinic-send-info', true) && (_vm.reportHist['clinic-send-check'] === 0 || _vm.utils.isBlank(_vm.reportHist['clinic-send-check']))) ? _c('div', [_c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.send_type')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-info']['send-type-post']),
      expression: "reportHist['clinic-send-info']['send-type-post']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.post')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-info']['send-type-fax']),
      expression: "reportHist['clinic-send-info']['send-type-fax']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fax')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-info']['send-type-email']),
      expression: "reportHist['clinic-send-info']['send-type-email']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.email')))]), _c('br')]), _c('div', {
    staticClass: "col-xs-9 col-xs-offset-3"
  }, [_vm._l((_vm.getNameList('report.send_timing')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.reportHist['clinic-send-info']['send-timing']),
        expression: "parseInt(list.id, 10) === reportHist['clinic-send-info']['send-timing']"
      }]
    }, [_vm._v(_vm._s(list.text) + "  ")])
  }), _vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.reportHist['clinic-send-info']['send-timing-hour']),
        expression: "parseInt(list.id, 10) === reportHist['clinic-send-info']['send-timing-hour']"
      }]
    }, [_vm._v(_vm._s(list.text))])
  })], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-info']['send-type-fax']),
      expression: "reportHist['clinic-send-info']['send-type-fax']"
    }]
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fax"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.fax')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.reportHist['clinic-send-info']['fax']))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-info']['send-type-email']),
      expression: "reportHist['clinic-send-info']['send-type-email']"
    }]
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.email')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.reportHist['clinic-send-info']['email']))])])]), _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.fusezi')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-info']['fusezi-flag'] === 1),
      expression: "reportHist['clinic-send-info']['fusezi-flag'] === 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_ari')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['clinic-send-info']['fusezi-flag'] !== 1),
      expression: "reportHist['clinic-send-info']['fusezi-flag'] !== 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_nashi')))])])])]) : _vm._e()]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHistReportTypeCareoffice),
      expression: "isHistReportTypeCareoffice"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.careoffice_send_check')))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-check'] === 1),
      expression: "reportHist['careoffice-send-check'] === 1"
    }]
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-square-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.send_info_change')))]), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.send_type')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-type-post']),
      expression: "reportHist['careoffice-send-type-post']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.post')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-type-fax']),
      expression: "reportHist['careoffice-send-type-fax']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fax')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-type-email']),
      expression: "reportHist['careoffice-send-type-email']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.email')))]), _c('br')]), _c('div', {
    staticClass: "col-xs-9 col-xs-offset-3"
  }, [_vm._l((_vm.getNameList('report.send_timing')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.reportHist['careoffice-send-timing']),
        expression: "parseInt(list.id, 10) === reportHist['careoffice-send-timing']"
      }]
    }, [_vm._v(_vm._s(list.text) + "  ")])
  }), _vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.reportHist['careoffice-send-timing-hour']),
        expression: "parseInt(list.id, 10) === reportHist['careoffice-send-timing-hour']"
      }]
    }, [_vm._v(_vm._s(list.text))])
  })], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-type-fax']),
      expression: "reportHist['careoffice-send-type-fax']"
    }]
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fax"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.fax')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.reportHist['careoffice-fax']))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-type-email']),
      expression: "reportHist['careoffice-send-type-email']"
    }]
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.email')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.reportHist['careoffice-email']))])])]), _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.fusezi')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-fusezi-flag'] === 1),
      expression: "reportHist['careoffice-fusezi-flag'] === 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_ari')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-fusezi-flag'] !== 1),
      expression: "reportHist['careoffice-fusezi-flag'] !== 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_nashi')))])])])]), (_vm.isSendSendInfoKey(_vm.reportHist, 'careoffice-send-info', true) && (_vm.reportHist['careoffice-send-check'] === 0 || _vm.utils.isBlank(_vm.reportHist['careoffice-send-check']))) ? _c('div', [_c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.send_type')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-info']['send-type-post']),
      expression: "reportHist['careoffice-send-info']['send-type-post']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.post')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-info']['send-type-fax']),
      expression: "reportHist['careoffice-send-info']['send-type-fax']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fax')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-info']['send-type-email']),
      expression: "reportHist['careoffice-send-info']['send-type-email']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.email')))]), _c('br')]), _c('div', {
    staticClass: "col-xs-9 col-xs-offset-3"
  }, [_vm._l((_vm.getNameList('report.send_timing')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.reportHist['careoffice-send-info']['send-timing']),
        expression: "parseInt(list.id, 10) === reportHist['careoffice-send-info']['send-timing']"
      }]
    }, [_vm._v(_vm._s(list.text) + "  ")])
  }), _vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.reportHist['careoffice-send-info']['send-timing-hour']),
        expression: "parseInt(list.id, 10) === reportHist['careoffice-send-info']['send-timing-hour']"
      }]
    }, [_vm._v(_vm._s(list.text))])
  })], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-info']['send-type-fax']),
      expression: "reportHist['careoffice-send-info']['send-type-fax']"
    }]
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fax"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.fax')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.reportHist['careoffice-send-info']['fax']))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-info']['type-email']),
      expression: "reportHist['careoffice-send-info']['type-email']"
    }]
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.email')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.reportHist['careoffice-send-info']['email']))])])]), _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.fusezi')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-info']['fusezi-flag'] === 1),
      expression: "reportHist['careoffice-send-info']['fusezi-flag'] === 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_ari')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportHist['careoffice-send-info']['fusezi-flag'] !== 1),
      expression: "reportHist['careoffice-send-info']['fusezi-flag'] !== 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_nashi')))])])])]) : _vm._e()])]), _c('th', [_vm._v(_vm._s(_vm.$t('report.teisyutsu')))]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['require_clinic_send']),
      expression: "report['require_clinic_send']"
    }],
    attrs: {
      "type": "checkbox",
      "name": "report[require_clinic_send]",
      "value": "1",
      "disabled": !_vm.isEdit || _vm.isRequireSendClinic
    },
    domProps: {
      "checked": Array.isArray(_vm.report['require_clinic_send']) ? _vm._i(_vm.report['require_clinic_send'], "1") > -1 : (_vm.report['require_clinic_send'])
    },
    on: {
      "change": _vm.onRequireClinicSendCheckChange,
      "click": function($event) {
        var $$a = _vm.report['require_clinic_send'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.report['require_clinic_send'] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.report['require_clinic_send'] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.report['require_clinic_send'] = $$c
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.clinic_send_check')))])])]), (_vm.report['require_clinic_send'] == 1) ? _c('div', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['clinic_send_check']),
      expression: "report['clinic_send_check']"
    }],
    attrs: {
      "type": "checkbox",
      "name": "report[clinic_send_check]",
      "value": "1",
      "disabled": !_vm.isEdit || _vm.report['require_clinic_send'] != 1
    },
    domProps: {
      "checked": Array.isArray(_vm.report['clinic_send_check']) ? _vm._i(_vm.report['clinic_send_check'], "1") > -1 : (_vm.report['clinic_send_check'])
    },
    on: {
      "change": _vm.onClinicSendCheckDefault,
      "click": function($event) {
        var $$a = _vm.report['clinic_send_check'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.report['clinic_send_check'] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.report['clinic_send_check'] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.report['clinic_send_check'] = $$c
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.send_info_change')))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['clinic_send_check'] === true || _vm.report['clinic_send_check'] == 1),
      expression: "report['clinic_send_check'] === true || report['clinic_send_check'] == 1"
    }],
    staticClass: "row form-horizontal form-group"
  }, [_c('label', {
    staticClass: "control-label font-normal col-xs-3"
  }, [_vm._v(_vm._s(_vm.$t('report.send_type')))]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['clinic_send_type_post']),
      expression: "report['clinic_send_type_post']"
    }],
    attrs: {
      "type": "checkbox",
      "name": "report[clinic_send_type_post]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": Array.isArray(_vm.report['clinic_send_type_post']) ? _vm._i(_vm.report['clinic_send_type_post'], null) > -1 : (_vm.report['clinic_send_type_post'])
    },
    on: {
      "click": function($event) {
        var $$a = _vm.report['clinic_send_type_post'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.report['clinic_send_type_post'] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.report['clinic_send_type_post'] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.report['clinic_send_type_post'] = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('report.post')))]), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['clinic_send_type_fax']),
      expression: "report['clinic_send_type_fax']"
    }],
    attrs: {
      "type": "checkbox",
      "name": "report[clinic_send_type_fax]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": Array.isArray(_vm.report['clinic_send_type_fax']) ? _vm._i(_vm.report['clinic_send_type_fax'], null) > -1 : (_vm.report['clinic_send_type_fax'])
    },
    on: {
      "click": function($event) {
        var $$a = _vm.report['clinic_send_type_fax'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.report['clinic_send_type_fax'] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.report['clinic_send_type_fax'] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.report['clinic_send_type_fax'] = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('report.fax')))]), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['clinic_send_type_email']),
      expression: "report['clinic_send_type_email']"
    }],
    attrs: {
      "type": "checkbox",
      "name": "report[clinic_send_type_email]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": Array.isArray(_vm.report['clinic_send_type_email']) ? _vm._i(_vm.report['clinic_send_type_email'], null) > -1 : (_vm.report['clinic_send_type_email'])
    },
    on: {
      "click": function($event) {
        var $$a = _vm.report['clinic_send_type_email'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.report['clinic_send_type_email'] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.report['clinic_send_type_email'] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.report['clinic_send_type_email'] = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('report.email')))]), _c('br')]), _c('div', {
    staticClass: "col-xs-7 col-xs-offset-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['clinic_send_timing']),
      expression: "report['clinic_send_timing']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.clinic_send_timing
    },
    attrs: {
      "name": "report[clinic_send_timing]",
      "disabled": !_vm.isEdit
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.report,
          $$idx = 'clinic_send_timing';
        if (!Array.isArray($$exp)) {
          _vm.report['clinic_send_timing'] = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        } else {
          $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0])
        }
      }
    }
  }, [_vm._l((_vm.getNameList('report.send_timing')), function(list) {
    return _c('option', {
      domProps: {
        "value": list.id
      }
    }, [_vm._v(_vm._s(list.text))])
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.clinic_send_timing),
      expression: "required.clinic_send_timing"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])], 2)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['clinic_send_timing'] !== null && parseInt(_vm.report['clinic_send_timing'], 10) === 0),
      expression: "report['clinic_send_timing'] !== null && parseInt(report['clinic_send_timing'], 10) === 0"
    }],
    staticClass: "col-xs-5 col-xs-offset-7",
    attrs: {
      "disabled": !_vm.isEdit
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['clinic_send_timing_hour']),
      expression: "report['clinic_send_timing_hour']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.clinic_send_timing_hour
    },
    attrs: {
      "name": "report[clinic_send_timing_hour]",
      "disabled": !_vm.isEdit
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.report,
          $$idx = 'clinic_send_timing_hour';
        if (!Array.isArray($$exp)) {
          _vm.report['clinic_send_timing_hour'] = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        } else {
          $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0])
        }
      }
    }
  }, [_vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('option', {
      domProps: {
        "value": list.id
      }
    }, [_vm._v(_vm._s(list.text))])
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.clinic_send_timing_hour),
      expression: "required.clinic_send_timing_hour"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])], 2)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['clinic_send_type_fax']),
      expression: "report['clinic_send_type_fax']"
    }]
  }, [_c('label', {
    staticClass: "control-label font-normal col-xs-3"
  }, [_vm._v(_vm._s(_vm.$t('report.fax')))]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "input-group input-label-left"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fax"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['clinic_fax']),
      expression: "report['clinic_fax']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.clinic_fax || _vm.required.clinic_fax_format
    },
    attrs: {
      "type": "tel",
      "maxlength": "13",
      "name": "report[clinic_fax]",
      "disabled": !_vm.isEdit,
      "placeholder": _vm.$t('placeholder.fax')
    },
    domProps: {
      "value": _vm._s(_vm.report['clinic_fax'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'clinic_fax';
        if (!Array.isArray($$exp)) {
          _vm.report['clinic_fax'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.clinic_fax),
      expression: "required.clinic_fax"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.clinic_fax_format),
      expression: "required.clinic_fax_format"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.invalid_tel')))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['clinic_send_type_email']),
      expression: "report['clinic_send_type_email']"
    }]
  }, [_c('label', {
    staticClass: "control-label font-normal col-xs-3"
  }, [_vm._v(_vm._s(_vm.$t('report.email')))]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "input-group input-label-left"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['clinic_email']),
      expression: "report['clinic_email']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.clinic_email || _vm.required.clinic_email_format
    },
    attrs: {
      "type": "email",
      "maxlength": "50",
      "name": "report[clinic_email]",
      "disabled": !_vm.isEdit,
      "placeholder": _vm.$t('placeholder.email')
    },
    domProps: {
      "value": _vm._s(_vm.report['clinic_email'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'clinic_email';
        if (!Array.isArray($$exp)) {
          _vm.report['clinic_email'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.clinic_email),
      expression: "required.clinic_email"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.clinic_email_format),
      expression: "required.clinic_email_format"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.invalid_email')))])])]), _c('label', {
    staticClass: "control-label font-normal col-xs-3"
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi')))]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['clinic_fusezi_flag']),
      expression: "report['clinic_fusezi_flag']"
    }],
    attrs: {
      "type": "checkbox",
      "name": "report[clinic_fusezi_flag]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": Array.isArray(_vm.report['clinic_fusezi_flag']) ? _vm._i(_vm.report['clinic_fusezi_flag'], "1") > -1 : (_vm.report['clinic_fusezi_flag'])
    },
    on: {
      "click": function($event) {
        var $$a = _vm.report['clinic_fusezi_flag'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.report['clinic_fusezi_flag'] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.report['clinic_fusezi_flag'] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.report['clinic_fusezi_flag'] = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('report.fusezi_msg1')) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.$t('report.fusezi_msg2')))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSendSendInfoKey(_vm.report, 'clinic_send_info', false) && (_vm.report['clinic_send_check'] === false || _vm.report['clinic_send_check'] == 0 || _vm.report['clinic_send_check'] == '' || _vm.report['clinic_send_check'] == null)),
      expression: "isSendSendInfoKey(report, 'clinic_send_info', false) && (report['clinic_send_check'] === false || report['clinic_send_check'] == 0 || report['clinic_send_check'] == '' || report['clinic_send_check'] == null)"
    }],
    staticClass: "row form-horizontal form-group"
  }, [_c('label', {
    staticClass: "control-label font-normal col-xs-3"
  }, [_vm._v(_vm._s(_vm.$t('report.send_type')))]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['clinic_send_info']['send_type_post']),
      expression: "report['clinic_send_info']['send_type_post']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.post')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['clinic_send_info']['send_type_fax']),
      expression: "report['clinic_send_info']['send_type_fax']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fax')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['clinic_send_info']['send_type_email']),
      expression: "report['clinic_send_info']['send_type_email']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.email')))]), _c('br')]), _c('div', {
    staticClass: "col-xs-9 col-xs-offset-3"
  }, [_vm._l((_vm.getNameList('report.send_timing')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.report['clinic_send_info']['send_timing']),
        expression: "parseInt(list.id, 10) === report['clinic_send_info']['send_timing']"
      }]
    }, [_vm._v(_vm._s(list.text) + "  ")])
  }), _vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.report['clinic_send_info']['send_timing_hour']),
        expression: "parseInt(list.id, 10) === report['clinic_send_info']['send_timing_hour']"
      }]
    }, [_vm._v(_vm._s(list.text))])
  })], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['clinic_send_info']['send_type_fax']),
      expression: "report['clinic_send_info']['send_type_fax']"
    }]
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fax"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.fax')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.report['clinic_send_info']['fax']))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['clinic_send_info']['send_type_email']),
      expression: "report['clinic_send_info']['send_type_email']"
    }]
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.email')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.report['clinic_send_info']['email']))])])]), _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.fusezi')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['clinic_send_info']['fusezi_flag'] === 1),
      expression: "report['clinic_send_info']['fusezi_flag'] === 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_ari')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['clinic_send_info']['fusezi_flag'] !== 1),
      expression: "report['clinic_send_info']['fusezi_flag'] !== 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_nashi')))])])])]) : _vm._e(), _c('div', [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['require_careoffice_send']),
      expression: "report['require_careoffice_send']"
    }],
    attrs: {
      "type": "checkbox",
      "name": "report[require_careoffice_send]",
      "value": "1",
      "disabled": !_vm.isEdit || _vm.isRequireSendCareoffice
    },
    domProps: {
      "checked": Array.isArray(_vm.report['require_careoffice_send']) ? _vm._i(_vm.report['require_careoffice_send'], "1") > -1 : (_vm.report['require_careoffice_send'])
    },
    on: {
      "change": _vm.onRequireCareofficeSendCheckChange,
      "click": function($event) {
        var $$a = _vm.report['require_careoffice_send'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.report['require_careoffice_send'] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.report['require_careoffice_send'] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.report['require_careoffice_send'] = $$c
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.careoffice_send_check')))])])]), (_vm.report['require_careoffice_send'] == 1) ? _c('div', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [(_vm.utils.isBlank(_vm.report['careman_id'])) ? [_c('div', {
    staticClass: "bg-danger",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.careoffice_send_not_setting1')))]), _c('br'), _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.careoffice_send_not_setting2')))])])] : [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['careoffice_send_check']),
      expression: "report['careoffice_send_check']"
    }],
    attrs: {
      "type": "checkbox",
      "name": "report[careoffice_send_check]",
      "value": "1",
      "disabled": !_vm.isEdit || _vm.report['require_careoffice_send'] != 1
    },
    domProps: {
      "checked": Array.isArray(_vm.report['careoffice_send_check']) ? _vm._i(_vm.report['careoffice_send_check'], "1") > -1 : (_vm.report['careoffice_send_check'])
    },
    on: {
      "change": _vm.onCareofficeSendCheckDefault,
      "click": function($event) {
        var $$a = _vm.report['careoffice_send_check'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.report['careoffice_send_check'] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.report['careoffice_send_check'] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.report['careoffice_send_check'] = $$c
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.send_info_change')))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['careoffice_send_check'] === true || _vm.report['careoffice_send_check'] == 1),
      expression: "report['careoffice_send_check'] === true || report['careoffice_send_check'] == 1"
    }],
    staticClass: "row form-horizontal form-group"
  }, [_c('label', {
    staticClass: "control-label font-normal col-xs-3"
  }, [_vm._v(_vm._s(_vm.$t('report.send_type')))]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['careoffice_send_type_post']),
      expression: "report['careoffice_send_type_post']"
    }],
    attrs: {
      "type": "checkbox",
      "name": "report[careoffice_send_type_post]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": Array.isArray(_vm.report['careoffice_send_type_post']) ? _vm._i(_vm.report['careoffice_send_type_post'], null) > -1 : (_vm.report['careoffice_send_type_post'])
    },
    on: {
      "click": function($event) {
        var $$a = _vm.report['careoffice_send_type_post'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.report['careoffice_send_type_post'] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.report['careoffice_send_type_post'] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.report['careoffice_send_type_post'] = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('report.post')))]), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['careoffice_send_type_fax']),
      expression: "report['careoffice_send_type_fax']"
    }],
    attrs: {
      "type": "checkbox",
      "name": "report[careoffice_send_type_fax]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": Array.isArray(_vm.report['careoffice_send_type_fax']) ? _vm._i(_vm.report['careoffice_send_type_fax'], null) > -1 : (_vm.report['careoffice_send_type_fax'])
    },
    on: {
      "click": function($event) {
        var $$a = _vm.report['careoffice_send_type_fax'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.report['careoffice_send_type_fax'] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.report['careoffice_send_type_fax'] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.report['careoffice_send_type_fax'] = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('report.fax')))]), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['careoffice_send_type_email']),
      expression: "report['careoffice_send_type_email']"
    }],
    attrs: {
      "type": "checkbox",
      "name": "report[careoffice_send_type_email]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": Array.isArray(_vm.report['careoffice_send_type_email']) ? _vm._i(_vm.report['careoffice_send_type_email'], null) > -1 : (_vm.report['careoffice_send_type_email'])
    },
    on: {
      "click": function($event) {
        var $$a = _vm.report['careoffice_send_type_email'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.report['careoffice_send_type_email'] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.report['careoffice_send_type_email'] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.report['careoffice_send_type_email'] = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('report.email')))]), _c('br')]), _c('div', {
    staticClass: "col-xs-7 col-xs-offset-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['careoffice_send_timing']),
      expression: "report['careoffice_send_timing']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.careoffice_send_timing
    },
    attrs: {
      "name": "report[careoffice_send_timing]",
      "disabled": !_vm.isEdit
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.report,
          $$idx = 'careoffice_send_timing';
        if (!Array.isArray($$exp)) {
          _vm.report['careoffice_send_timing'] = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        } else {
          $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0])
        }
      }
    }
  }, [_vm._l((_vm.getNameList('report.send_timing')), function(list) {
    return _c('option', {
      domProps: {
        "value": list.id
      }
    }, [_vm._v(_vm._s(list.text))])
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.careoffice_send_timing),
      expression: "required.careoffice_send_timing"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])], 2)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['careoffice_send_timing'] !== null && parseInt(_vm.report['careoffice_send_timing'], 10) === 0),
      expression: "report['careoffice_send_timing'] !== null && parseInt(report['careoffice_send_timing'], 10) === 0"
    }],
    staticClass: "col-xs-5 col-xs-offset-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['careoffice_send_timing_hour']),
      expression: "report['careoffice_send_timing_hour']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.careoffice_send_timing_hour
    },
    attrs: {
      "name": "report[careoffice_send_timing_hour]",
      "disabled": !_vm.isEdit
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.report,
          $$idx = 'careoffice_send_timing_hour';
        if (!Array.isArray($$exp)) {
          _vm.report['careoffice_send_timing_hour'] = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        } else {
          $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0])
        }
      }
    }
  }, [_vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('option', {
      domProps: {
        "value": list.id
      }
    }, [_vm._v(_vm._s(list.text))])
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.careoffice_send_timing_hour),
      expression: "required.careoffice_send_timing_hour"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])], 2)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['careoffice_send_type_fax']),
      expression: "report['careoffice_send_type_fax']"
    }]
  }, [_c('label', {
    staticClass: "control-label font-normal col-xs-3"
  }, [_vm._v(_vm._s(_vm.$t('report.fax')))]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "input-group input-label-left"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fax"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['careoffice_fax']),
      expression: "report['careoffice_fax']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.careoffice_fax || _vm.required.careoffice_fax_format
    },
    attrs: {
      "type": "tel",
      "maxlength": "13",
      "name": "report[careoffice_fax]",
      "disabled": !_vm.isEdit,
      "placeholder": _vm.$t('placeholder.fax')
    },
    domProps: {
      "value": _vm._s(_vm.report['careoffice_fax'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'careoffice_fax';
        if (!Array.isArray($$exp)) {
          _vm.report['careoffice_fax'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.careoffice_fax),
      expression: "required.careoffice_fax"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.careoffice_fax_format),
      expression: "required.careoffice_fax_format"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.invalid_tel')))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['careoffice_send_type_email']),
      expression: "report['careoffice_send_type_email']"
    }]
  }, [_c('label', {
    staticClass: "control-label font-normal col-xs-3"
  }, [_vm._v(_vm._s(_vm.$t('report.email')))]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "input-group input-label-left"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['careoffice_email']),
      expression: "report['careoffice_email']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.careoffice_email || _vm.required.careoffice_email_format
    },
    attrs: {
      "type": "email",
      "maxlength": "50",
      "name": "report[careoffice_email]",
      "disabled": !_vm.isEdit,
      "placeholder": _vm.$t('placeholder.email')
    },
    domProps: {
      "value": _vm._s(_vm.report['careoffice_email'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'careoffice_email';
        if (!Array.isArray($$exp)) {
          _vm.report['careoffice_email'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.careoffice_email),
      expression: "required.careoffice_email"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.careoffice_email_format),
      expression: "required.careoffice_email_format"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.invalid_email')))])])]), _c('label', {
    staticClass: "control-label font-normal col-xs-3"
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi')))]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['careoffice_fusezi_flag']),
      expression: "report['careoffice_fusezi_flag']"
    }],
    attrs: {
      "type": "checkbox",
      "name": "report[careoffice_fusezi_flag]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": Array.isArray(_vm.report['careoffice_fusezi_flag']) ? _vm._i(_vm.report['careoffice_fusezi_flag'], "1") > -1 : (_vm.report['careoffice_fusezi_flag'])
    },
    on: {
      "click": function($event) {
        var $$a = _vm.report['careoffice_fusezi_flag'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.report['careoffice_fusezi_flag'] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.report['careoffice_fusezi_flag'] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.report['careoffice_fusezi_flag'] = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('report.fusezi_msg1')) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.$t('report.fusezi_msg2')))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSendSendInfoKey(_vm.report, 'careoffice_send_info', false) && (_vm.report['careoffice_send_check'] === false || _vm.report['careoffice_send_check'] == 0 || _vm.report['careoffice_send_check'] == '' || _vm.report['careoffice_send_check'] == null)),
      expression: "isSendSendInfoKey(report, 'careoffice_send_info', false) && (report['careoffice_send_check'] === false || report['careoffice_send_check'] == 0 || report['careoffice_send_check'] == '' || report['careoffice_send_check'] == null)"
    }],
    staticClass: "row form-horizontal form-group"
  }, [_c('label', {
    staticClass: "control-label font-normal col-xs-3"
  }, [_vm._v(_vm._s(_vm.$t('report.send_type')))]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['careoffice_send_info']['send_type_post']),
      expression: "report['careoffice_send_info']['send_type_post']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.post')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['careoffice_send_info']['send_type_fax']),
      expression: "report['careoffice_send_info']['send_type_fax']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fax')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['careoffice_send_info']['send_type_email']),
      expression: "report['careoffice_send_info']['send_type_email']"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.email')))]), _c('br')]), _c('div', {
    staticClass: "col-xs-9 col-xs-offset-3"
  }, [_vm._l((_vm.getNameList('report.send_timing')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.report['careoffice_send_timing']),
        expression: "parseInt(list.id, 10) === report['careoffice_send_timing']"
      }]
    }, [_vm._v(_vm._s(list.text) + "  ")])
  }), _vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.report['careoffice_send_timing_hour']),
        expression: "parseInt(list.id, 10) === report['careoffice_send_timing_hour']"
      }]
    }, [_vm._v(_vm._s(list.text))])
  })], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['careoffice_send_info']['send_type_fax']),
      expression: "report['careoffice_send_info']['send_type_fax']"
    }]
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fax"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.fax')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.report['careoffice_send_info']['fax']))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['careoffice_send_info']['send_type_email']),
      expression: "report['careoffice_send_info']['send_type_email']"
    }]
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.email')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.report['careoffice_send_info']['email']))])])]), _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.fusezi')))])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['careoffice_send_info']['fusezi_flag'] === 1),
      expression: "report['careoffice_send_info']['fusezi_flag'] === 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_ari')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report['careoffice_send_info']['fusezi_flag'] !== 1),
      expression: "report['careoffice_send_info']['fusezi_flag'] !== 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_nashi')))])])])]], 2) : _vm._e()])]), _c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.houmonbi')))]), _c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportHist['delivery-date']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.houmonbi')))]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.report['delivery_date']),
      expression: "report['delivery_date']",
      modifiers: {
        "lazy": true
      }
    }],
    class: {
      required: _vm.required.delivery_date || _vm.required.delivery_date_format
    },
    attrs: {
      "name": "report[delivery_date]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": (_vm.report['delivery_date'])
    },
    on: {
      "change": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'delivery_date';
        if (!Array.isArray($$exp)) {
          _vm.report['delivery_date'] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }, function($event) {
        _vm.onChangeDeliveryDate()
      }]
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.delivery_date),
      expression: "required.delivery_date"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])], 1)]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckHaiyaku),
      expression: "isCheckHaiyaku"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.haiyaku_naiyou')))]), _c('a', {
    staticClass: "btn btn-info hidden-xs",
    class: {
      disabled: !_vm.isEdit
    },
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.onTakingDeliCopy()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Copy')))])]), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.haiyaku_naiyou')))]), _c('a', {
    staticClass: "btn btn-info visible-xs",
    class: {
      disabled: !_vm.isEdit
    },
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.$t('Copy')))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckHaiyaku),
      expression: "isCheckHaiyaku"
    }]
  }, [_c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "4",
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.shohou_nichi')) + " " + _vm._s(_vm.reportHist['taking-period']) + _vm._s(_vm.$t('report.nichi'))), _c('br'), _vm._v(_vm._s(_vm.$t('report.fukuyoukikan')) + " " + _vm._s(_vm.reportHist['taking-start-date']) + " " + _vm._s(_vm.reportHist['taking-start-method-name']) + " " + _vm._s(_vm.$t('report.divide')) + " " + _vm._s(_vm.reportHist['taking-end-date']) + " " + _vm._s(_vm.reportHist['taking-end-method-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.shohou_nichi')))]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "autocomplete-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['taking_period']),
      expression: "report['taking_period']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.taking_period_format
    },
    attrs: {
      "type": "text",
      "maxlength": "2",
      "name": "report[taking_period]",
      "disabled": !_vm.isEdit,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.report['taking_period'])
    },
    on: {
      "change": function($event) {
        _vm.onCalcHaiyakuDate('taking')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'taking_period';
        if (!Array.isArray($$exp)) {
          _vm.report['taking_period'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('button', {
    staticClass: "pull-down-btn",
    attrs: {
      "id": "taking_period_autocomplete",
      "type": "button",
      "disabled": !_vm.isEdit
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onFocusPeriod('taking')
      },
      "blur": function($event) {
        _vm.onBlurPeriod()
      }
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTakingListShow),
      expression: "isTakingListShow"
    }],
    staticClass: "options-list"
  }, _vm._l((_vm.getNameList('report.period')), function(list) {
    return _c('li', [_c('span', {
      attrs: {
        "data-id": 'taking',
        "data-name": list.id
      },
      on: {
        "click": function($event) {
          _vm.onSetPeriod('taking', list.id)
        }
      }
    }, [_vm._v(_vm._s(list.text))])])
  }))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.taking_period_format),
      expression: "required.taking_period_format"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.invalid_taking_period')))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckHaiyaku),
      expression: "isCheckHaiyaku"
    }]
  }, [_c('th', [_c('span', [_vm._v(_vm._s(_vm.$t('report.fukuyoukikan')))])]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.report['taking_start_date']),
      expression: "report['taking_start_date']",
      modifiers: {
        "lazy": true
      }
    }],
    class: {
      required: _vm.required.taking_start_date_format
    },
    attrs: {
      "name": "report[taking_start_date]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": (_vm.report['taking_start_date'])
    },
    on: {
      "change": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'taking_start_date';
        if (!Array.isArray($$exp)) {
          _vm.report['taking_start_date'] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }, function($event) {
        _vm.onCalcHaiyakuDate('taking'), _vm.onClearStartDate('taking')
      }]
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['taking_start_method']),
      expression: "report['taking_start_method']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.taking_start_method
    },
    attrs: {
      "name": "report[taking_start_method]",
      "disabled": !_vm.isEdit
    },
    on: {
      "change": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'taking_start_method';
        if (!Array.isArray($$exp)) {
          _vm.report['taking_start_method'] = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        } else {
          $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0])
        }
      }, function($event) {
        _vm.onCalcHaiyakuDate('taking')
      }]
    }
  }, _vm._l((_vm.getNameList('report.method_name')), function(list) {
    return _c('option', {
      domProps: {
        "value": list.id
      }
    }, [_vm._v(_vm._s(list.text))])
  })), _c('span', [_vm._v("〜")])], 1), _c('div', {
    staticClass: "form-inline"
  }, [_c('date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.report['taking_end_date']),
      expression: "report['taking_end_date']",
      modifiers: {
        "lazy": true
      }
    }],
    class: {
      required: _vm.required.taking_end_date_format
    },
    attrs: {
      "name": "report[taking_end_date]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": (_vm.report['taking_end_date'])
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.report,
          $$idx = 'taking_end_date';
        if (!Array.isArray($$exp)) {
          _vm.report['taking_end_date'] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['taking_end_method']),
      expression: "report['taking_end_method']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.taking_end_method
    },
    attrs: {
      "name": "report[taking_end_method]",
      "disabled": !_vm.isEdit
    },
    on: {
      "change": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'taking_end_method';
        if (!Array.isArray($$exp)) {
          _vm.report['taking_end_method'] = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        } else {
          $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0])
        }
      }, function($event) {
        _vm.onCalcHaiyakuDate('taking')
      }]
    }
  }, _vm._l((_vm.getNameList('report.method_name')), function(list) {
    return _c('option', {
      domProps: {
        "value": list.id
      }
    }, [_vm._v(_vm._s(list.text))])
  }))], 1)])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckHaiyaku),
      expression: "isCheckHaiyaku"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.konkai_haiyaku')))]), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.konkai_haiyaku')))])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckHaiyaku),
      expression: "isCheckHaiyaku"
    }]
  }, [_c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "4",
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.shohou_nichi')) + " " + _vm._s(_vm.reportHist['deli-period']) + _vm._s(_vm.$t('report.nichi'))), _c('br'), _vm._v(_vm._s(_vm.$t('report.fukuyoukikan')) + " " + _vm._s(_vm.reportHist['deli-start-date']) + " " + _vm._s(_vm.reportHist['deli-start-method-name']) + " " + _vm._s(_vm.$t('report.divide')) + " " + _vm._s(_vm.reportHist['deli-end-date']) + " " + _vm._s(_vm.reportHist['deli-end-method-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.shohou_nichi')))]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "autocomplete-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['deli_period']),
      expression: "report['deli_period']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.deli_period_format
    },
    attrs: {
      "type": "text",
      "maxlength": "2",
      "name": "report[deli_period]",
      "disabled": !_vm.isEdit,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.report['deli_period'])
    },
    on: {
      "change": function($event) {
        _vm.onCalcHaiyakuDate('deli')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'deli_period';
        if (!Array.isArray($$exp)) {
          _vm.report['deli_period'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('button', {
    staticClass: "pull-down-btn",
    attrs: {
      "id": "deli_period_autocomplete",
      "type": "button",
      "disabled": !_vm.isEdit
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onFocusPeriod('deli')
      },
      "blur": function($event) {
        _vm.onBlurPeriod()
      }
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDeliListShow),
      expression: "isDeliListShow"
    }],
    staticClass: "options-list"
  }, _vm._l((_vm.getNameList('report.period')), function(list) {
    return _c('li', [_c('span', {
      attrs: {
        "data-id": 'deli',
        "data-name": list.id
      },
      on: {
        "click": function($event) {
          _vm.onSetPeriod('deli', list.id)
        }
      }
    }, [_vm._v(_vm._s(list.text))])])
  }))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.deli_period_format),
      expression: "required.deli_period_format"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.invalid_taking_period')))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckHaiyaku),
      expression: "isCheckHaiyaku"
    }]
  }, [_c('th', [_vm._v(_vm._s(_vm.$t('report.fukuyoukikan')))]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.report['deli_start_date']),
      expression: "report['deli_start_date']",
      modifiers: {
        "lazy": true
      }
    }],
    class: {
      required: _vm.required.deli_start_date_format
    },
    attrs: {
      "name": "report[deli_start_date]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": (_vm.report['deli_start_date'])
    },
    on: {
      "change": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'deli_start_date';
        if (!Array.isArray($$exp)) {
          _vm.report['deli_start_date'] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }, function($event) {
        _vm.onCalcHaiyakuDate('deli'), _vm.onClearStartDate('deli')
      }]
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['deli_start_method']),
      expression: "report['deli_start_method']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.deli_start_method
    },
    attrs: {
      "name": "report[deli_start_method]",
      "disabled": !_vm.isEdit
    },
    on: {
      "change": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'deli_start_method';
        if (!Array.isArray($$exp)) {
          _vm.report['deli_start_method'] = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        } else {
          $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0])
        }
      }, function($event) {
        _vm.onCalcHaiyakuDate('deli')
      }]
    }
  }, _vm._l((_vm.getNameList('report.method_name')), function(list) {
    return _c('option', {
      domProps: {
        "value": list.id
      }
    }, [_vm._v(_vm._s(list.text))])
  })), _c('span', [_vm._v("〜")])], 1), _c('div', {
    staticClass: "form-inline"
  }, [_c('date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.report['deli_end_date']),
      expression: "report['deli_end_date']",
      modifiers: {
        "lazy": true
      }
    }],
    class: {
      required: _vm.required.deli_end_date_format
    },
    attrs: {
      "name": "report[deli_end_date]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": (_vm.report['deli_end_date'])
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.report,
          $$idx = 'deli_end_date';
        if (!Array.isArray($$exp)) {
          _vm.report['deli_end_date'] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['deli_end_method']),
      expression: "report['deli_end_method']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.deli_end_method
    },
    attrs: {
      "name": "report[deli_end_method]",
      "disabled": !_vm.isEdit
    },
    on: {
      "change": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'deli_end_method';
        if (!Array.isArray($$exp)) {
          _vm.report['deli_end_method'] = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        } else {
          $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0])
        }
      }, function($event) {
        _vm.onCalcHaiyakuDate('deli')
      }]
    }
  }, _vm._l((_vm.getNameList('report.method_name')), function(list) {
    return _c('option', {
      domProps: {
        "value": list.id
      }
    }, [_vm._v(_vm._s(list.text))])
  }))], 1)])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckHenkou),
      expression: "isCheckHenkou"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.henkouten')))]), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v("変更点")]), _c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.isEdit
    },
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.onPhraseModalShow('prescribe_change')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('report.phrase')))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckHenkou),
      expression: "isCheckHenkou"
    }]
  }, [_c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "4",
      "rowspan": "2"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.reportHist['prescribe-change']))])]), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['prescribe_check']),
      expression: "report['prescribe_check']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[prescribe_change_rdo]",
      "value": "prescribe_change",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['prescribe_check'], "prescribe_change")
    },
    on: {
      "change": function($event) {
        _vm.onPrescribeChange(_vm.$t('report.prescribe_change.rdo1'))
      },
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'prescribe_check';
        if (!Array.isArray($$exp)) {
          _vm.report['prescribe_check'] = "prescribe_change"
        } else {
          $$exp.splice($$idx, 1, "prescribe_change")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.prescribe_change.rdo1')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['prescribe_check']),
      expression: "report['prescribe_check']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[prescribe_change_rdo]",
      "value": "prescribe_no_change",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['prescribe_check'], "prescribe_no_change")
    },
    on: {
      "change": function($event) {
        _vm.onPrescribeChange(_vm.$t('report.prescribe_change.rdo2'))
      },
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'prescribe_check';
        if (!Array.isArray($$exp)) {
          _vm.report['prescribe_check'] = "prescribe_no_change"
        } else {
          $$exp.splice($$idx, 1, "prescribe_no_change")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.prescribe_change.rdo2')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['prescribe_check']),
      expression: "report['prescribe_check']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[prescribe_change_rdo]",
      "value": "prescribe_special",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['prescribe_check'], "prescribe_special")
    },
    on: {
      "change": function($event) {
        _vm.onPrescribeChange(_vm.$t('report.prescribe_change.rdo3'))
      },
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'prescribe_check';
        if (!Array.isArray($$exp)) {
          _vm.report['prescribe_check'] = "prescribe_special"
        } else {
          $$exp.splice($$idx, 1, "prescribe_special")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.prescribe_change.rdo3')))])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckHenkou),
      expression: "isCheckHenkou"
    }]
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['prescribe_change']),
      expression: "report['prescribe_change']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.prescribe_change || _vm.required.prescribe_change_format
    },
    attrs: {
      "rows": "4",
      "maxlength": "250",
      "id": "prescribe_change",
      "name": "report[prescribe_change]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": _vm._s(_vm.report['prescribe_change'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'prescribe_change';
        if (!Array.isArray($$exp)) {
          _vm.report['prescribe_change'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.prescribe_change),
      expression: "required.prescribe_change"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.prescribe_change_format),
      expression: "required.prescribe_change_format"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.print_length')))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckShidou),
      expression: "isCheckShidou"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.shidou_naiyou')))]), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.shidou_naiyou')))]), _c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.isEdit
    },
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.onPhraseModalShow('soap_comment')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('report.phrase')))]), _c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.isEdit
    },
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.onClickMedicines()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('report.kusuri_reference')))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckShidou),
      expression: "isCheckShidou"
    }]
  }, [_c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.reportHist['soap-comment']))])]), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['soap_comment']),
      expression: "report['soap_comment']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.soap_comment || _vm.required.soap_comment_format
    },
    attrs: {
      "rows": "8",
      "maxlength": "320",
      "id": "soap_comment",
      "name": "report[soap_comment]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": _vm._s(_vm.report['soap_comment'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'soap_comment';
        if (!Array.isArray($$exp)) {
          _vm.report['soap_comment'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.soap_comment),
      expression: "required.soap_comment"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.soap_comment_format),
      expression: "required.soap_comment_format"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.print_length')))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.kakunin_jikou')))]), _c('a', {
    staticClass: "btn btn-info hidden-xs",
    class: {
      disabled: !_vm.isEdit
    },
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.onConfirmCopy()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Copy')))])]), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.kakunin_jikou')))]), _c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.isEdit
    },
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.onNoProblem()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('report.mondai_nashi')))]), _c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.isEdit
    },
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.onPhraseModalShow('confirm_comment')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('report.phrase')))]), _c('a', {
    staticClass: "btn btn-info visible-xs",
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.$t('Copy')))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.taking_status')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['taking-status-name']))]), _c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "2",
      "rowspan": "13"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.reportHist['confirm-comment']))])]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.taking_status')))]), _c('td', {
    class: {
      required: _vm.required.taking_status
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['taking_status']),
      expression: "report['taking_status']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[taking_status]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['taking_status'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'taking_status';
        if (!Array.isArray($$exp)) {
          _vm.report['taking_status'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.failure')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['taking_status']),
      expression: "report['taking_status']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[taking_status]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['taking_status'], "1")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'taking_status';
        if (!Array.isArray($$exp)) {
          _vm.report['taking_status'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.good')))])])]), _c('td', {
    staticClass: "mp0",
    attrs: {
      "colspan": "2",
      "rowspan": "13"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['confirm_comment']),
      expression: "report['confirm_comment']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.confirm_comment || _vm.required.confirm_comment_format
    },
    attrs: {
      "name": "report[confirm_comment]",
      "rows": "12",
      "maxlength": "320",
      "id": "confirm_comment",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": _vm._s(_vm.report['confirm_comment'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'confirm_comment';
        if (!Array.isArray($$exp)) {
          _vm.report['confirm_comment'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.confirm_comment),
      expression: "required.confirm_comment"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.confirm_comment_format),
      expression: "required.confirm_comment_format"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.print_length')))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.remnant_status')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['remnant-status-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.remnant_status')))]), _c('td', {
    class: {
      required: _vm.required.remnant_status
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['remnant_status']),
      expression: "report['remnant_status']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[remnant_status]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['remnant_status'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'remnant_status';
        if (!Array.isArray($$exp)) {
          _vm.report['remnant_status'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.nashi')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['remnant_status']),
      expression: "report['remnant_status']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[remnant_status]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['remnant_status'], "1")
    },
    on: {
      "click": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'remnant_status';
        if (!Array.isArray($$exp)) {
          _vm.report['remnant_status'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }, function($event) {
        _vm.onRadioButtonStatusTrue('remnant_status')
      }]
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.ari')))])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.condition_change')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['condition-change-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.condition_change')))]), _c('td', {
    class: {
      required: _vm.required.condition_change
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['condition_change']),
      expression: "report['condition_change']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[condition_change]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['condition_change'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'condition_change';
        if (!Array.isArray($$exp)) {
          _vm.report['condition_change'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.nashi')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['condition_change']),
      expression: "report['condition_change']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[condition_change]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['condition_change'], "1")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'condition_change';
        if (!Array.isArray($$exp)) {
          _vm.report['condition_change'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.ari')))])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.side_effect_status')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['side-effect-status-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.side_effect_status')))]), _c('td', {
    class: {
      required: _vm.required.side_effect_status
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['side_effect_status']),
      expression: "report['side_effect_status']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[side_effect_status]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['side_effect_status'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'side_effect_status';
        if (!Array.isArray($$exp)) {
          _vm.report['side_effect_status'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.nashi')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['side_effect_status']),
      expression: "report['side_effect_status']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[side_effect_status]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['side_effect_status'], "1")
    },
    on: {
      "click": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'side_effect_status';
        if (!Array.isArray($$exp)) {
          _vm.report['side_effect_status'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }, function($event) {
        _vm.onRadioButtonStatusTrue('side_effect_status')
      }]
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.ari')))])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.interaction')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['interaction-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.interaction')))]), _c('td', {
    class: {
      required: _vm.required.interaction
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['interaction']),
      expression: "report['interaction']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[interaction]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['interaction'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'interaction';
        if (!Array.isArray($$exp)) {
          _vm.report['interaction'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.nashi')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['interaction']),
      expression: "report['interaction']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[interaction]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['interaction'], "1")
    },
    on: {
      "click": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'interaction';
        if (!Array.isArray($$exp)) {
          _vm.report['interaction'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }, function($event) {
        _vm.onRadioButtonStatusTrue('interaction')
      }]
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.ari')))])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.take_interaction')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['take-interaction-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.take_interaction')))]), _c('td', {
    class: {
      required: _vm.required.take_interaction
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['take_interaction']),
      expression: "report['take_interaction']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[take_interaction]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['take_interaction'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'take_interaction';
        if (!Array.isArray($$exp)) {
          _vm.report['take_interaction'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.nashi')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['take_interaction']),
      expression: "report['take_interaction']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[take_interaction]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['take_interaction'], "1")
    },
    on: {
      "click": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'take_interaction';
        if (!Array.isArray($$exp)) {
          _vm.report['take_interaction'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }, function($event) {
        _vm.onRadioButtonStatusTrue('take_interaction')
      }]
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.ari')))])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.complication')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['complication-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.complication')))]), _c('td', {
    class: {
      required: _vm.required.complication
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['complication']),
      expression: "report['complication']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[complication]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['complication'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'complication';
        if (!Array.isArray($$exp)) {
          _vm.report['complication'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.nashi')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['complication']),
      expression: "report['complication']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[complication]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['complication'], "1")
    },
    on: {
      "click": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'complication';
        if (!Array.isArray($$exp)) {
          _vm.report['complication'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }, function($event) {
        _vm.onRadioButtonStatusTrue('complication')
      }]
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.ari')))])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.other_dosage')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['other-dosage-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.other_dosage')))]), _c('td', {
    class: {
      required: _vm.required.other_dosage
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['other_dosage']),
      expression: "report['other_dosage']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[other_dosage]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['other_dosage'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'other_dosage';
        if (!Array.isArray($$exp)) {
          _vm.report['other_dosage'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.nashi')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['other_dosage']),
      expression: "report['other_dosage']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[other_dosage]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['other_dosage'], "1")
    },
    on: {
      "click": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'other_dosage';
        if (!Array.isArray($$exp)) {
          _vm.report['other_dosage'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }, function($event) {
        _vm.onRadioButtonStatusTrue('other_dosage')
      }]
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.ari')))])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.otc_combination')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['otc-combination-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.otc_combination')))]), _c('td', {
    class: {
      required: _vm.required.otc_combination
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['otc_combination']),
      expression: "report['otc_combination']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[otc_combination]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['otc_combination'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'otc_combination';
        if (!Array.isArray($$exp)) {
          _vm.report['otc_combination'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.nashi')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['otc_combination']),
      expression: "report['otc_combination']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[otc_combination]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['otc_combination'], "1")
    },
    on: {
      "click": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'otc_combination';
        if (!Array.isArray($$exp)) {
          _vm.report['otc_combination'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }, function($event) {
        _vm.onRadioButtonStatusTrue('otc_combination')
      }]
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.ari')))])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.visit_duty')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['visit-duty-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.visit_duty')))]), _c('td', {
    class: {
      required: _vm.required.visit_duty
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['visit_duty']),
      expression: "report['visit_duty']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[visit_duty]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['visit_duty'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'visit_duty';
        if (!Array.isArray($$exp)) {
          _vm.report['visit_duty'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.nashi')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['visit_duty']),
      expression: "report['visit_duty']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[visit_duty]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['visit_duty'], "1")
    },
    on: {
      "click": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'visit_duty';
        if (!Array.isArray($$exp)) {
          _vm.report['visit_duty'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }, function($event) {
        _vm.onRadioButtonStatusTrue('visit_duty')
      }]
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.ari')))])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.dispense_idea')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['dispense-idea-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.dispense_idea')))]), _c('td', {
    class: {
      required: _vm.required.dispense_idea
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['dispense_idea']),
      expression: "report['dispense_idea']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[dispense_idea]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['dispense_idea'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'dispense_idea';
        if (!Array.isArray($$exp)) {
          _vm.report['dispense_idea'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.nashi')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['dispense_idea']),
      expression: "report['dispense_idea']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[dispense_idea]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['dispense_idea'], "1")
    },
    on: {
      "click": [function($event) {
        var $$exp = _vm.report,
          $$idx = 'dispense_idea';
        if (!Array.isArray($$exp)) {
          _vm.report['dispense_idea'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }, function($event) {
        _vm.onRadioButtonStatusTrue('dispense_idea')
      }]
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.ari')))])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.last_request')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['last-request-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.last_request')))]), _c('td', {
    class: {
      required: _vm.required.last_request
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['last_request']),
      expression: "report['last_request']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[last_request]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['last_request'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'last_request';
        if (!Array.isArray($$exp)) {
          _vm.report['last_request'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.nashi')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['last_request']),
      expression: "report['last_request']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[last_request]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['last_request'], "1")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'last_request';
        if (!Array.isArray($$exp)) {
          _vm.report['last_request'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.ari')))])])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckKakunin),
      expression: "isCheckKakunin"
    }]
  }, [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.medicine_notebook')))]), _c('td', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.reportHist['medicine-notebook-name']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.medicine_notebook')))]), _c('td', {
    class: {
      required: _vm.required.medicine_notebook
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['medicine_notebook']),
      expression: "report['medicine_notebook']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[medicine_notebook]",
      "value": "0",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['medicine_notebook'], "0")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'medicine_notebook';
        if (!Array.isArray($$exp)) {
          _vm.report['medicine_notebook'] = "0"
        } else {
          $$exp.splice($$idx, 1, "0")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.nashi')))])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['medicine_notebook']),
      expression: "report['medicine_notebook']"
    }],
    attrs: {
      "type": "radio",
      "name": "report[medicine_notebook]",
      "value": "1",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "checked": _vm._q(_vm.report['medicine_notebook'], "1")
    },
    on: {
      "click": function($event) {
        var $$exp = _vm.report,
          $$idx = 'medicine_notebook';
        if (!Array.isArray($$exp)) {
          _vm.report['medicine_notebook'] = "1"
        } else {
          $$exp.splice($$idx, 1, "1")
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.ari')))])])])]), _c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.create_time')))]), _c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportHist['report-create-time']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.create_time')))]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.report['report_create_time_date']),
      expression: "report['report_create_time_date']",
      modifiers: {
        "lazy": true
      }
    }],
    class: {
      required: _vm.required.report_create_time_date_format
    },
    attrs: {
      "name": "report[report_create_time_date]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": (_vm.report['report_create_time_date'])
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.report,
          $$idx = 'report_create_time_date';
        if (!Array.isArray($$exp)) {
          _vm.report['report_create_time_date'] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['report_create_time_time']),
      expression: "report['report_create_time_time']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.report_create_time_time_format
    },
    attrs: {
      "type": "text",
      "maxlength": "5",
      "name": "report[report_create_time_time]",
      "disabled": !_vm.isEdit,
      "placeholder": _vm.$t('placeholder.time')
    },
    domProps: {
      "value": _vm._s(_vm.report['report_create_time_time'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'report_create_time_time';
        if (!Array.isArray($$exp)) {
          _vm.report['report_create_time_time'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  })], 1)])]), _c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.update_time')))]), _c('td', {
    staticClass: "hidden-xs",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportHist['report-update-time']))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.update_time')))]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.report['report_update_time_date']),
      expression: "report['report_update_time_date']",
      modifiers: {
        "lazy": true
      }
    }],
    class: {
      required: _vm.required.report_update_time_date_format
    },
    attrs: {
      "name": "report[report_update_time_date]",
      "disabled": !_vm.isEdit
    },
    domProps: {
      "value": (_vm.report['report_update_time_date'])
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.report,
          $$idx = 'report_update_time_date';
        if (!Array.isArray($$exp)) {
          _vm.report['report_update_time_date'] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report['report_update_time_time']),
      expression: "report['report_update_time_time']"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.report_update_time_time_format
    },
    attrs: {
      "type": "text",
      "maxlength": "5",
      "name": "report[report_update_time_time]",
      "disabled": !_vm.isEdit,
      "placeholder": _vm.$t('placeholder.time')
    },
    domProps: {
      "value": _vm._s(_vm.report['report_update_time_time'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.report,
          $$idx = 'report_update_time_time';
        if (!Array.isArray($$exp)) {
          _vm.report['report_update_time_time'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  })], 1)])]), _c('tr', [_c('td', {
    staticClass: "col-span-4 hidden-xs",
    attrs: {
      "colspan": "4"
    }
  }, [_c('a', {
    staticClass: "btn btn-default",
    class: {
      'disabled': !_vm.isReportHistNext
    },
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.onReportHistNext()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.zenkai')))])]), _c('a', {
    staticClass: "btn btn-default",
    class: {
      'disabled': !_vm.isReportHistPrev
    },
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.onReportHistPrev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.jikai')))])])]), _c('td', {
    staticClass: "col-span-4 text-right",
    attrs: {
      "colspan": "4"
    }
  }, [(_vm.isPostStatusPost) ? [(_vm.isAdminOrPharmacist) ? [_c('a', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': !_vm.isRequiredComplete
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#confirm_update_modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Update')))])])] : _vm._e()] : [(_vm.isEditBtn) ? _c('span', [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.onEditMode()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Edit')))])])]) : _c('span', [_c('a', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': !_vm.isRequiredComplete
    },
    on: {
      "click": function($event) {
        _vm.onClickSaveReport({
          type: 'report',
          post_status: 'no_post',
          update_resend: false
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Complete')))])]), _c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.isEdit
    },
    on: {
      "click": function($event) {
        _vm.onClickSaveReport({
          type: 'report',
          post_status: 'temp',
          update_resend: false
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])])])]], 2)])])])]) : _vm._e()])]), _c('div', {
    staticClass: "margin-top"
  }, [_c('div', {
    attrs: {
      "id": "smartPhone"
    }
  }, [(_vm.patient != null) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': !_vm.isPatientPrev
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.patientPrev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.patient_prev')))])])]), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "4px",
      "padding": "5px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.patient['patient-name']))])]), _c('span', [_vm._v(" ")]), _c('span', {
    staticClass: "label",
    class: _vm.getDispColor,
    staticStyle: {
      "margin-top": "4px",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.display_now')))])]), _c('div', {
    staticClass: "col-xs-7"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "4px",
      "padding": "5px"
    }
  }, [_c('strong', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.totalCount ? _vm.totalCount : 0) + _vm._s(_vm.$t('report.patient_count')))]), _c('span', [_vm._v(_vm._s(_vm.$t('report.patient_select')))])])])])]), _c('div', {
    staticClass: "col-xs-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': !_vm.isPatientNext
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.patientNext()
      }
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('report.patient_next')))]), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])]) : _vm._e(), _c('div', {
    staticClass: "row margin-top-divide"
  }, [_c('div', {
    staticClass: "col-xs-12 text-right"
  }, [(!_vm.isReportDetail) ? [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goPatient
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Back')))])])] : _vm._e(), (_vm.isReportDetail) ? [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goReportDetail
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Back')))])])] : _vm._e(), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.backToTop()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Top')))])])], 2)])])])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phraseSaveIds),
      expression: "phraseSaveIds"
    }],
    attrs: {
      "id": "phrase_using_count",
      "type": "hidden"
    },
    domProps: {
      "value": _vm._s(_vm.phraseSaveIds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phraseSaveIds = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "select_phrase_modal_button",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#select_phrase_modal"
    }
  }, [_vm._v("保存確認モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "select_phrase_modal",
      "role": "dialog",
      "aria-labelledby": "selectPhraseModalLabel",
      "data-target": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('report.modal.phrase')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [(_vm.phrases != null) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phraseTypeId),
      expression: "phraseTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.phraseTypeId = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.phrases), function(ph) {
    return _c('option', {
      domProps: {
        "value": ph['phrase_type_id']
      }
    }, [_vm._v(_vm._s(ph['phrase_type_name']))])
  }))]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phraseSort),
      expression: "phraseSort"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.phraseSort = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.modal.phrase_select0')))]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.modal.phrase_select1')))])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticStyle: {
      "height": "400px",
      "width": "100%",
      "overflow-y": "scroll"
    }
  }, _vm._l((_vm.phrasesDetail), function(detail) {
    return _c('div', {
      staticClass: "btn-group-vertical",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data-toggle": "buttons"
      }
    }, [_c('label', {
      staticClass: "btn btn-default btn-lg btn-block phrase_id",
      class: {
        active: detail['active']
      },
      staticStyle: {
        "width": "99%"
      },
      on: {
        "click": function($event) {
          _vm.onClickSetSelectPhrase(detail['phrase_id'])
        }
      }
    }, [_c('span', {
      staticClass: "phrase_text",
      staticStyle: {
        "font-size": "16px",
        "word-wrap": "break-word",
        "white-space": "normal",
        "display": "block"
      }
    }, [_vm._v(_vm._s(detail['phrase']))])])])
  }))])])]) : _vm._e()]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.setPhraseText()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Setting')))]), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "confirm_modal_button",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#confirm_modal"
    }
  }, [_vm._v("保存確認モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "confirm_modal",
      "role": "dialog",
      "aria-labelledby": "confirmModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('report.modal.save_confirm')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "45px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.modal.save_confirm_msg')))])])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.isPostStatusPost) ? [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "data-toggle": "modal",
      "data-target": "#confirm_update_modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Update')))])] : [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onClickAllSaveReport({
          type: 'report',
          post_status: 'temp',
          update_resend: false
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Save')))])], _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onConfirmNoSave()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Save None')))]), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])], 2)])])])])]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "add_confirm_modal",
      "role": "dialog",
      "aria-labelledby": "confirmModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('report.modal.add_confirm')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "45px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.modal.add_confirm_msg')))])])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onAddNewReport()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Yes')))]), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('No')))])])])])])])]), _c('a', {
    staticClass: "hide",
    attrs: {
      "id": "print_new_window_link",
      "type": "button",
      "target": "_blank",
      "href": ""
    }
  }), _c('a', {
    staticClass: "hide",
    attrs: {
      "id": "print_download_link",
      "type": "button",
      "download": "",
      "href": ""
    }
  }), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "print_modal_button",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#print_modal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "print_modal",
      "role": "dialog",
      "aria-labelledby": "printModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('report.modal.print')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "form-group form-inline"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.houmonbi')))]), _c('date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.printDeliveryDate),
      expression: "printDeliveryDate",
      modifiers: {
        "lazy": true
      }
    }],
    class: {
      required: _vm.requiredPrint.printDeliveryDate || _vm.requiredPrint.printDeliveryDate_format
    },
    staticStyle: {
      "width": "160px"
    },
    domProps: {
      "value": (_vm.printDeliveryDate)
    },
    on: {
      "change": function($event) {
        _vm.printDeliveryDate = $event
      }
    }
  })], 1), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('report.modal.print_msg')))])])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.requiredPrint.printDeliveryDate || _vm.requiredPrint.printDeliveryDate_format) ? [_c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('Print')))]), _c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('Download')))])] : [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onPrint('print')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Print')))]), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onPrint('download')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Download')))])], _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])], 2)])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "bulk_date_modal_button",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#bulk_date_modal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bulk_date_modal",
      "role": "dialog",
      "aria-labelledby": "bulkDateModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('report.modal.date')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "form-group form-inline"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.modal.date_msg1')))]), _c('date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.bulkDate),
      expression: "bulkDate",
      modifiers: {
        "lazy": true
      }
    }],
    class: {
      required: _vm.requiredBulk.bulkDate || _vm.requiredBulk.bulkDate_format
    },
    staticStyle: {
      "width": "160px"
    },
    domProps: {
      "value": (_vm.bulkDate)
    },
    on: {
      "change": function($event) {
        _vm.bulkDate = $event
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.modal.date_msg2')))]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkDateType),
      expression: "bulkDateType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "bulk_date_type"
    },
    on: {
      "change": function($event) {
        _vm.bulkDateType = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.shohoubi')))]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.chouzaibi')))]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.houmonbi')))]), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.fukuyoukaishi')))])]), _c('span', [_vm._v(_vm._s(_vm.$t('report.modal.date_msg3')))])], 1)]), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.allReportEditData != null) ? _c('div', [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "max-width": "40px"
    }
  }, [_vm._v(" ")]), _c('th', {
    staticStyle: {
      "max-width": "40px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.modal.date_list1')))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.modal.date_list2')))]), _c('th', {
    staticStyle: {
      "max-width": "65px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.modal.date_list3')))]), _c('th', [(_vm.bulkDateType == 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('report.shohoubi')))]) : _vm._e(), (_vm.bulkDateType == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('report.chouzaibi')))]) : _vm._e(), (_vm.bulkDateType == 3) ? _c('span', [_vm._v(_vm._s(_vm.$t('report.houmonbi')))]) : _vm._e(), (_vm.bulkDateType == 4) ? _c('span', [_vm._v(_vm._s(_vm.$t('report.fukuyoukaishi')))]) : _vm._e()]), (_vm.bulkDateType == 4) ? _c('th', [_c('span', [_vm._v(_vm._s(_vm.$t('report.fukuyoukaishi')))]), _c('small', {
    staticClass: "text-muted",
    staticStyle: {
      "font-size": "-3em"
    }
  }, [_vm._v("(" + _vm._s(_vm.$t('report.konkai_haiyaku')) + ")")])]) : _vm._e()])]), _c('tbody', _vm._l((_vm.allReportEditData), function(data, index) {
    return _c('tr', [_c('td', [(_vm.isBulkDateEditList(data['report'])) ? _c('div', [_c('input', {
      staticClass: "bulkDateCheckbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": index
      }
    })]) : _c('div', [_c('span', [_vm._v(" ")])])]), _c('td', [_vm._v(_vm._s(index + 1))]), _c('td', [_vm._v(_vm._s(data['patient']['data']['attributes']['patient-name']))]), _c('td', [_vm._v(_vm._s(data['patient']['data']['attributes']['sex']))]), _c('td', [(_vm.bulkDateType == 1) ? _c('span', [_vm._v(_vm._s(data['report']['prescribe_date']))]) : _vm._e(), (_vm.bulkDateType == 2) ? _c('span', [_vm._v(_vm._s(data['report']['make_date']))]) : _vm._e(), (_vm.bulkDateType == 3) ? _c('span', [_vm._v(_vm._s(data['report']['delivery_date']))]) : _vm._e(), (_vm.bulkDateType == 4) ? _c('span', [_vm._v(_vm._s(data['report']['taking_start_date']))]) : _vm._e()]), (_vm.bulkDateType == 4) ? _c('td', [(_vm.bulkDateType == 4) ? _c('span', [_vm._v(_vm._s(data['report']['deli_start_date']))]) : _vm._e()]) : _vm._e()])
  }))])]) : _vm._e()])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.isBulkComplete) ? [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.setBulkDate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Setting')))])] : [_c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('Setting')))])], _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])], 2)])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "confirm_teiki_modal_button",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#confirm_teiki_modal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "confirm_teiki_modal",
      "role": "dialog",
      "aria-labelledby": "confirmModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('report.modal.teiki')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "45px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.modal.teiki_msg')))])])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onClickAllSaveReport({
          type: 'batch',
          post_status: 'post',
          update_resend: true
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OK')))]), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('No')))])])])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "confirm_sokuji_modal_button",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#confirm_sokuji_modal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "confirm_sokuji_modal",
      "role": "dialog",
      "aria-labelledby": "confirmModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('report.modal.sokuji')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5), _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "form-group form-inline"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.modal.sokuji_msg1')))]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sokujiSendTimingHour),
      expression: "sokujiSendTimingHour"
    }],
    staticClass: "form-control",
    class: {
      required: _vm.required.clinic_send_timing_hour
    },
    on: {
      "change": function($event) {
        _vm.sokujiSendTimingHour = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('option', {
      domProps: {
        "value": list.id
      }
    }, [_vm._v(_vm._s(list.text))])
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required.clinic_send_timing_hour),
      expression: "required.clinic_send_timing_hour"
    }],
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])], 2), _c('span', [_vm._v(_vm._s(_vm.$t('report.modal.sokuji_msg2')))])])])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onClickAllSaveReport({
          type: 'instance',
          post_status: 'post',
          update_resend: true
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OK')))]), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('No')))])])])])])])]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "confirm_update_modal",
      "role": "dialog",
      "aria-labelledby": "confirmModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('report.modal.re_send')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(6), _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.modal.re_send_msg')))]), _c('br'), _c('br'), (_vm.isAdminOrPharmacist) ? [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onClickTeikiModalShow(500)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Send Report Ordinary')))]), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onSokujiModalShow(500)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Send Report Immediately')))])] : _vm._e(), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onClickAllSaveReport({
          type: 'report',
          post_status: 'temp',
          update_resend: false
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('report.modal.none_re_send_msg_save')))])], 2)])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "imageModalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#imageModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "imageModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modalcenter"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(7), _c('div', {
    staticClass: "modal-img_footer text-center"
  }, [_c('p', {
    attrs: {
      "id": "imageModalText"
    }
  }), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "delete_confirm_modal",
      "role": "dialog",
      "aria-labelledby": "confirmModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('report.modal.delete_confirm')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(8), _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "45px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.modal.delete_msg')))])])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onClickDeleteReport()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Yes')))]), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('No')))])])])])])])]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "help-modal",
      "role": "dialog",
      "aria-labelledby": "helpModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(9), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "helpModal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Help Modal.Modal Title.Report Create')))])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "modal-body-cell"
  }, [_c('table', [_c('tbody', [_c('tr', [_vm._m(10), _c('td', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('Help Modal.Discription.Print')))])])])])])]), _c('div', {
    staticClass: "modal-body-cell"
  }, [_c('table', [_c('tbody', [_c('tr', [_vm._m(11), _c('td', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('Help Modal.Discription.Send Report Ordinary')))])])])])])]), _c('div', {
    staticClass: "modal-body-cell"
  }, [_c('table', [_c('tbody', [_c('tr', [_vm._m(12), _c('td', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('Help Modal.Discription.Send Report Immediately')))])])])])])]), _c('div', {
    staticClass: "modal-body-cell"
  }, [_c('table', [_c('tbody', [_c('tr', [_vm._m(13), _c('td', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('Help Modal.Discription.Input Support')))])])])])])]), _c('div', {
    staticClass: "modal-body-cell"
  }, [_c('table', [_c('tbody', [_c('tr', [_vm._m(14), _c('td', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('Help Modal.Discription.Autoinput Date')))])])])])])]), _c('div', {
    staticClass: "modal-body-cell"
  }, [_vm._m(15), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Help Modal.Discription.Disp Item')))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "id": "imageModalImg",
      "src": "",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "help-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/help-image/print.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "help-image"
  }, [_c('img', {
    staticClass: "button",
    attrs: {
      "src": require("../../../static/help-image/send_report_ordinary.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "help-image"
  }, [_c('img', {
    staticClass: "button",
    attrs: {
      "src": require("../../../static/help-image/send_report_immediately.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "help-image"
  }, [_c('img', {
    staticClass: "button",
    attrs: {
      "src": require("../../../static/help-image/input_support.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "help-image"
  }, [_c('img', {
    staticClass: "button",
    attrs: {
      "src": require("../../../static/help-image/autoinput_date.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-image"
  }, [_c('img', {
    staticClass: "button",
    attrs: {
      "src": require("../../../static/help-image/disp_item.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44809bc2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/report-edit.pug
// module id = 379
// module chunks = 1